import { cn } from '@/lib/tailwind';
import { IconArrowLeft, IconArrowRight } from '@/components/icons';
import type { UiSliderNavigationProps } from './UiSlider.types';
import { GRID_GUTTER } from '@/lib/ui/tailwind-mapping.constants';

export function UiSliderNavigation({
    canScrollLeft,
    canScrollRight,
    onPrev,
    onNext,
    className,
}: UiSliderNavigationProps) {
    return (
        <div className={cn('flex mb-6', GRID_GUTTER['both'], 'max-w-page-xl', className)}>
            <div className="flex gap-x-5 ml-auto">
                <button
                    type="button"
                    aria-label="Previous"
                    disabled={!canScrollLeft}
                    onClick={onPrev}
                    className="text-color cursor-pointer size-8 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                    <IconArrowLeft />
                </button>

                <button
                    type="button"
                    aria-label="Next"
                    disabled={!canScrollRight}
                    onClick={onNext}
                    className="text-color cursor-pointer size-8 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                    <IconArrowRight />
                </button>
            </div>
        </div>
    );
}
